import API from 'services/api';

const api = new API();

// Unwrap the shared `{status, value}` envelope: a non-zero status rejects with the error payload.
const fetchValue = (url, options = {}) =>
    new Promise((resolve, reject) => {
        api.getJson(url, { credentials: 'include', ...options })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });

// { org_groups, is_demo_server } — the data the legacy Angular template injected as a JS global.
export const getInviteConfig = () => fetchValue('/register/invite_config');

// Reuses the unchanged legacy endpoint. The backend always returns status 0; the outcome is in
// the value payload: { result: true, link } on success or { result: false, error } on failure.
export const sendInvite = inviteDetails => fetchValue('/register/send_invite', { method: 'POST', body: inviteDetails });
